module.exports = __webpack_public_path__ + "img/reportChicken_3.8a2399f3.png";